import { i18nTranslate, getLocaleCodeFromUrl, enableHeaderMFE } from 'src/utils'
import {
  customerContainer,
  accountsContainer,
  storeContainer,
} from 'src/models'
import { toastState } from 'src/views/components'
import { getLocalStorage } from 'src/utils'
import { consentIpAddress, APPConfig, convertToBoolean } from 'config/appConfig'
import { pageNames } from 'src/routes/pathParams'
import { checkIsNativeApp } from 'src/utils/reactNativeAppUtils'
import { enableJitsuSF } from 'src/utils'

function getCategoryLinks(category, isTopLevelCategory) {
  const { identifier, isFromOurImpact = false, properties } = category
  const templateUrl = category?.milestone?.templateUrl || ''
  const templateId = category?.milestone?.templateId || ''
  const templateName = templateUrl
    .split('/')
    .find(item => item.match(/template[\d]/))
  if (isFromOurImpact) {
    return properties?.href
  } else {
    const template =
      templateName || (templateId ? `template${templateId}` : `catalog`)
    const url = isTopLevelCategory ? '/categoryLanding/' : `/${template}/`
    return `${url}${identifier}`
  }
}

async function getConsent(term1, term2, acceptancePayload) {
  const { consents } = await customerContainer.signupConsents()
  const isToEnableIronClad =
    APPConfig?.getAppConfig()?.FEATURE_IRONCLAD_IMPLEMENTATION === 'true' ||
    false
  const otherInfo = {
    browser: 'chrome',
    device: 'mobile',
    geoLocation:
      storeContainer.currentRegion || getLocalStorage('currentRegion') || '',
    ipAddress: consentIpAddress,
  }
  const signUpConsents = []

  consents.forEach(consent => {
    const Id = consent.id
    let consentInfo = ''

    if (
      term1 &&
      consent.title === 'I acknowledge I have read Sales performance'
    ) {
      consentInfo = {
        consentId: Id,
        ...otherInfo,
        createdTimestamp: consent.createdTimestamp,
        updatedTimestamp: consent.updatedTimestamp,
      }
      signUpConsents.push(consentInfo)
    }
    if (
      term2 &&
      consent.title === 'I have Read, Understand, Agree to BA agreement'
    ) {
      consentInfo = {
        consentId: Id,
        ...otherInfo,
        createdTimestamp: consent.createdTimestamp,
        updatedTimestamp: consent.updatedTimestamp,
      }
      signUpConsents.push(consentInfo)
    }
    if (consent.title === 'Terms & Conditions') {
      consentInfo = {
        consentId: Id,
        ...otherInfo,
        createdTimestamp: consent.createdTimestamp,
        updatedTimestamp: consent.updatedTimestamp,
      }
      signUpConsents.push(consentInfo)
    }
  })

  if (isToEnableIronClad) {
    const acceptanceInfoPage1 = {
      ...otherInfo,
      id: accountsContainer?.IronCladGroupId,
      title: 'contracts_ironclad_page1',
      acceptanceData: acceptancePayload?.[0],
    }
    const acceptanceInfoPage2 = {
      ...otherInfo,
      id: accountsContainer?.IronCladGroupId,
      title: 'contracts_ironclad_page2',
      acceptanceData: acceptancePayload?.[1],
    }
    const acceptanceInfoPage3 = {
      ...otherInfo,
      id: accountsContainer?.IronCladGroupId,
      title: 'contracts_ironclad_page3',
      acceptanceData: acceptancePayload?.[2],
    }
    signUpConsents.push(
      acceptanceInfoPage1,
      acceptanceInfoPage2,
      acceptanceInfoPage3
    )
  }
  const accountId = customerContainer.accountId
  const accountType =
    customerContainer?.profileResponse?.accounts?.type || ''

  if (storeContainer.isLegalAgreementsVerificationRequired(accountType)) {
    const propertiesPostData = {
      properties: [
        { attributeId: 'legalAgreementsReceived', value: 'true' },
      ],
    }
    const loadParams = {
      endPointName: 'sponsorUpdateAccount',
      pathParams: `${accountId}/properties`,
      postData: propertiesPostData,
    }

    const response = await customerContainer?.fetchResponse(loadParams)
    if (customerContainer?.isSuccessResponse(response)) {
      accountsContainer.legalAgreementsReceived = true
      accountsContainer.signUpIronCladCheck = {
        clickWrap1: false,
        clickWrap2: false,
        clickWrap3: false,
      }
      toastState?.setToastMessage(
        i18nTranslate(
          'legalAgreementsSuccess',
          'Terms and Conditions accepted successfully',
          { nameSpace: 'ssr-resource' }
        ),
        true
      )
      return response
    } else {
      toastState.setToastMessage(
        i18nTranslate(
          'legalAgreementsFailure',
          'Terms and Conditions acceptance failed, please try again later',
          { nameSpace: 'ssr-resource' }
        ),
        false
      )
    }
  } else {
    const accType = getLocalStorage('accountType')
    const typeId = accountsContainer.profileResponse.typeId
    const name = accountsContainer.profileResponse.name

    const postData = {
      conversionType: 'TEMP_2_PERM',
      userConsent: [],
      account: {
        id: accountId,
        name: name,
        typeId: typeId,
        type: accType,
        addresses: [],
        customer: {},
      },
    }
    postData.userConsent = signUpConsents
    const loadParams = {
      endPointName: 'nextgenAccountUpgrade',
      pathParams: `${accountId}/upgrade`,
      postData,
    }

    const response = await customerContainer?.fetchResponse(loadParams)
    if (customerContainer?.isSuccessResponse(response)) {
      accountsContainer.signUpIronCladCheck = {
        clickWrap1: false,
        clickWrap2: false,
        clickWrap3: false,
      }
      toastState?.setToastMessage(
        i18nTranslate(
          'temptoPermSuccess',
          'Congratulations! Your account has been successfully converted from temporary to permanent',
          { nameSpace: 'ssr-resource' }
        ),
        true
      )
      return response
    } else {
      toastState.setToastMessage(
        i18nTranslate(
          'temptoPermFailure',
          'Temporary to Permanent account conversion failure, please try again later ',
          { nameSpace: 'ssr-resource' }
        ),
        false
      )
    }
  }
}

function showTempPopup() {
  const selectedLocaleCode = getLocaleCodeFromUrl()?.split('_')?.[1]
  const eqMarketLocales = APPConfig?.getAppConfig()?.eqMarketLocales || ['US']
  if (selectedLocaleCode === 'undefined') return false
  // Mandatory flow is locale-driven only; standard flow still requires the account's own countryCode to match.
  const isMandatoryTermsPopup = convertToBoolean(
    APPConfig?.getAppConfig()?.enableMandatoryTempToPermTerms
  )
  if (isMandatoryTermsPopup) {
    return eqMarketLocales?.includes(selectedLocaleCode?.toLowerCase())
  }
  let userCountry = ''
  customerContainer?.profileResponse?.accounts?.properties?.forEach(el => {
    if (el.attributeId === 'countryCode') userCountry = el.value
  })
  if (selectedLocaleCode != userCountry) return false
  return eqMarketLocales?.includes(userCountry?.toLowerCase())
}

function isEnableReEnrollNotificationPopup() {
  return (
    convertToBoolean(
      APPConfig?.getAppConfig()?.enableReEnrollNotificationPopup === 'true'
    ) || false
  )
}
function enableToshowBlackOutDateSelection() {
  return (
    convertToBoolean(
      APPConfig?.getAppConfig()?.enableToshowBlackOutDateSelection === 'true'
    ) || false
  )
}
function isEnableMemberAgreementCheckout() {
  return (
    convertToBoolean(
      APPConfig?.getAppConfig()?.enableMemberAgreementCheckout === 'true'
    ) || false
  )
}
function isEnableExpressCheckoutMemberAgreement() {
  return (
    convertToBoolean(
      APPConfig?.getAppConfig()?.enableExpressCheckoutMemberAgreement === 'true'
    ) || false
  )
}
function isEnableExpressCheckoutMemberAgreementForRegisteredUser() {
  return (
    convertToBoolean(
      APPConfig?.getAppConfig()
        ?.enableExpressCheckoutMemberAgreementForRegisteredUser === 'true'
    ) || false
  )
}

function isEnableMemberAgreementsChange() {
  return (
    convertToBoolean(
      APPConfig?.getAppConfig()?.enableMemberAgreementsChange === 'true'
    ) || false
  )
}
function disableSignTextMobileHeader() {
  return (
    convertToBoolean(
      APPConfig?.getAppConfig()?.disableSignTextMobileHeader === 'true'
    ) || false
  )
}
function checkIfReEnroll() {
  return isEnableReEnrollNotificationPopup() && customerContainer?.reEnroll
}

function isEnableIronCladIntegrationAPI() {
  return (
    convertToBoolean(
      APPConfig?.getAppConfig()?.enableIronCladIntegrationApi === 'true'
    ) || false
  )
}

// Create additional shop items
function createAdditionalShopItems(shopTranslations) {
  const discoverNuSkinBeauty = i18nTranslate(
    'megamenu.shop.discover.nuskin.beauty',
    'Discover Nu Skin Beauty',
    { nameSpace: 'ssr-resource' }
  )
  const nuSkinGlowKit = i18nTranslate(
    'megamenu.shop.nuskin.glow.kit',
    'Nu Skin Glow Kit',
    { nameSpace: 'ssr-resource' }
  )
  const discoverPharmanexNutrition = i18nTranslate(
    'megamenu.shop.discover.pharmanex.nutrition',
    'Discover Pharmanex Nutrition',
    { nameSpace: 'ssr-resource' }
  )
  const coreNutritionKit = i18nTranslate(
    'megamenu.shop.core.nutrition.kit',
    'Core Nutrition Kit',
    { nameSpace: 'ssr-resource' }
  )

  return {
    properties: {
      meta_title: '',
      name: '',
      description: '',
    },
    parentId: 'shop_beauty_wellness',
    identifier: 'featured_products',
    isFirstColumn: true,
    isNonClickable: true,
    subCategories: [
      {
        properties: {
          meta_title: discoverNuSkinBeauty,
          name: discoverNuSkinBeauty,
          description: discoverNuSkinBeauty,
          href: `/site/product/discover-nu-skin-beauty`,
        },
        parentId: 'featured_products',
        identifier: 'discover_nuskin_beauty',
        isVerticalListItem: true,
        isFromOurImpact: true,
      },
      {
        properties: {
          meta_title: nuSkinGlowKit,
          name: nuSkinGlowKit,
          description: nuSkinGlowKit,
          href: `/product/nuskin-glow-kit`,
        },
        parentId: 'featured_products',
        identifier: 'nuskin_glow_kit',
        isVerticalListItem: true,
        isFromOurImpact: true,
      },
      {
        properties: {
          meta_title: discoverPharmanexNutrition,
          name: discoverPharmanexNutrition,
          description: discoverPharmanexNutrition,
          href: `/site/product/discover-pharmanex-nutrition`,
        },
        parentId: 'featured_products',
        identifier: 'discover_pharmanex_nutrition',
        isVerticalListItem: true,
        isFromOurImpact: true,
      },
      {
        properties: {
          meta_title: coreNutritionKit,
          name: coreNutritionKit,
          description: coreNutritionKit,
          href: `/product/core-nutrition-kit`,
        },
        parentId: 'featured_products',
        identifier: 'core_nutrition_kit',
        isVerticalListItem: true,
        isFromOurImpact: true,
      },
    ],
  }
}

// Create additional professional care items
function createAdditionalProfessionalCareItems() {
  const discoverSerenuProfessional = i18nTranslate(
    'megamenu.professional.discover.serenu.professional',
    'Discover Serenu Professional',
    { nameSpace: 'ssr-resource' }
  )
  const serenuProfessionalKit = i18nTranslate(
    'megamenu.professional.serenu.professional.kit',
    'Serenu Professional Kit',
    { nameSpace: 'ssr-resource' }
  )

  return {
    properties: {
      meta_title: '',
      name: '',
      description: '',
    },
    parentId: 'professional_care',
    identifier: 'featured_professional_products',
    isFirstColumn: true,
    isNonClickable: true,
    subCategories: [
      {
        properties: {
          meta_title: discoverSerenuProfessional,
          name: discoverSerenuProfessional,
          description: discoverSerenuProfessional,
          href: `/site/product/discover-serenu-professional`,
        },
        parentId: 'featured_professional_products',
        identifier: 'discover_serenu_professional',
        isVerticalListItem: true,
        isFromOurImpact: true,
      },
      {
        properties: {
          meta_title: serenuProfessionalKit,
          name: serenuProfessionalKit,
          description: serenuProfessionalKit,
          href: `/product/serenu-professional-kit`,
        },
        parentId: 'featured_professional_products',
        identifier: 'serenu_professional_kit',
        isVerticalListItem: true,
        isFromOurImpact: true,
      },
    ],
  }
}

// Get hardcoded menu items
function getHardCodedMenusIN(baseUrl, nameSpace) {
  // Get translations for Our Company section
  const ourCompanyText = i18nTranslate('megamenu.ourcompany', 'Our Company', {
    nameSpace,
  })

  // Our Story section
  const ourStoryText = i18nTranslate(
    'megamenu.ourcompany.ourstory',
    'Our Story',
    {
      nameSpace,
    }
  )
  const aboutUsText = i18nTranslate('megamenu.ourcompany.aboutus', 'About Us', {
    nameSpace,
  })
  const ourOpportunityText = i18nTranslate(
    'megamenu.ourcompany.ouropportunity',
    'Our Opportunity',
    {
      nameSpace,
    }
  )
  const forceForGoodText = i18nTranslate(
    'megamenu.ourcompany.forceforgood',
    'Force For Good',
    {
      nameSpace,
    }
  )

  // Our Science section
  const ourScienceText = i18nTranslate(
    'megamenu.ourcompany.ourscience',
    'Our Science',
    {
      nameSpace,
    }
  )
  const productScienceText = i18nTranslate(
    'megamenu.ourcompany.productscience',
    'Product Science',
    {
      nameSpace,
    }
  )
  const scienceAdvisoryBoardText = i18nTranslate(
    'megamenu.ourcompany.scienceadvisoryboard',
    'Science Advisory Board',
    {
      nameSpace,
    }
  )

  // Our Impact section
  const ourImpactText = i18nTranslate(
    'megamenu.ourcompany.ourimpact',
    'Our Impact',
    {
      nameSpace,
    }
  )
  const socialImpactText = i18nTranslate(
    'megamenu.ourcompany.socialimpact',
    'Social Impact',
    {
      nameSpace,
    }
  )
  const sustainabilityText = i18nTranslate(
    'megamenu.ourcompany.sustainability',
    'Sustainability',
    {
      nameSpace,
    }
  )
  const ingredientsPhilosophyText = i18nTranslate(
    'megamenu.ourcompany.ingredientsphilosophy',
    'Our Ingredients Philosophy',
    {
      nameSpace,
    }
  )

  const hardcodedList = [
    {
      properties: {
        meta_title: ourCompanyText,
        name: ourCompanyText,
        description: ourCompanyText,
      },
      parentId: 'top',
      subCategories: [
        // Our Story Section
        {
          properties: {
            meta_title: ourStoryText,
            name: ourStoryText,
            description: ourStoryText,
          },
          parentId: 'ourcompany',
          subCategories: [
            {
              properties: {
                meta_title: aboutUsText,
                name: aboutUsText,
                description: aboutUsText,
                href: `${baseUrl}/site/company/about-us`,
              },
              parentId: 'ourstory',
              identifier: 'aboutus',
              isFromOurImpact: true,
            },
            {
              properties: {
                meta_title: ourOpportunityText,
                name: ourOpportunityText,
                description: ourOpportunityText,
                href: `${baseUrl}/site/opportunity/india-local-market-opportunity`,
              },
              parentId: 'ourstory',
              identifier: 'ouropportunity',
              isFromOurImpact: true,
            },
            {
              properties: {
                meta_title: forceForGoodText,
                name: forceForGoodText,
                description: forceForGoodText,
                href: `${baseUrl}/site/forecforgood/home`,
              },
              parentId: 'ourstory',
              identifier: 'forceforgood',
              isFromOurImpact: true,
            },
          ],
          identifier: 'ourstory',
        },
        // Our Science Section
        {
          properties: {
            meta_title: ourScienceText,
            name: ourScienceText,
            description: ourScienceText,
          },
          parentId: 'ourcompany',
          subCategories: [
            {
              properties: {
                meta_title: productScienceText,
                name: productScienceText,
                description: productScienceText,
                href: `${baseUrl}/site/science/nu-skin-science`,
              },
              parentId: 'ourscience',
              identifier: 'productscience',
              isFromOurImpact: true,
            },
            {
              properties: {
                meta_title: scienceAdvisoryBoardText,
                name: scienceAdvisoryBoardText,
                description: scienceAdvisoryBoardText,
                href: `${baseUrl}/site/science/sab`,
              },
              parentId: 'ourscience',
              identifier: 'scienceadvisoryboard',
              isFromOurImpact: true,
            },
          ],
          identifier: 'ourscience',
        },
        // Our Impact Section
        {
          properties: {
            meta_title: ourImpactText,
            name: ourImpactText,
            description: ourImpactText,
          },
          parentId: 'ourcompany',
          subCategories: [
            {
              properties: {
                meta_title: socialImpactText,
                name: socialImpactText,
                description: socialImpactText,
                href: `${baseUrl}/site/forecforgood/reports`,
              },
              parentId: 'ourimpact',
              identifier: 'socialimpact',
              isFromOurImpact: true,
            },
            {
              properties: {
                meta_title: sustainabilityText,
                name: sustainabilityText,
                description: sustainabilityText,
                href: `${baseUrl}/site/forecforgood/sustainability`,
              },
              parentId: 'ourimpact',
              identifier: 'sustainability',
              isFromOurImpact: true,
            },
            {
              properties: {
                meta_title: ingredientsPhilosophyText,
                name: ingredientsPhilosophyText,
                description: ingredientsPhilosophyText,
                href: `${baseUrl}/site/forecforgood/ingredients-philosophy`,
              },
              parentId: 'ourimpact',
              identifier: 'ingredientsphilosophy',
              isFromOurImpact: true,
            },
          ],
          identifier: 'inourimpact',
        },
      ],
      identifier: 'ourcompany',
      isDummyCategory: true,
    },
  ]

  const mobileHardcodedList = JSON.parse(JSON.stringify(hardcodedList))

  return {
    hardcodedList,
    mobileHardcodedList,
  }
}

/**
 * Returns true when the header and global modals should be completely suppressed.
 *
 * These pages either run inside a native-app webview (Stella/Vera) where there is
 * no visible header, or they embed their own full-screen UI where showing account
 * modals (phone verification, re-enroll, DCSV, etc.) would be disruptive or broken:
 *
 * - Region-select page        — standalone locale picker
 * - Native-app query param    — Stella/Vera webview flag
 * - checkIsNativeApp()        — JS-bridge native-app detection
 * - Klarna checkout           — Klarna-hosted iframe flow
 * - Online-return MFE pages   — returnSteps / returnConfirmation (legacy header only;
 *                               skipped when storefront Header MFE is enabled)
 * - Jitsu SF signup pages     — signUp / jitsuParticipantsInvite
 *
 * @param {object} location — react-router location object (location.pathname, location.search)
 * @returns {boolean}
 */
function shouldSuppressHeaderAndModals(location) {
  const pathname = location?.pathname || ''
  const searchParams = location?.search || ''

  const isRegionPage = pathname === pageNames.SelectRegion
  const isKlarnaCheckoutPage = pathname === pageNames.klarnaCheckout

  const isNativeAppQueryParam =
    new URLSearchParams(searchParams)?.get('isNativeApp') === 'true'
  const isNativeApp = checkIsNativeApp() || false

  const enableOnlineReturnMFE =
    convertToBoolean(APPConfig?.getAppConfig()?.enableOnlineReturnMFE) || false
  const isFromReturn =
    enableOnlineReturnMFE &&
    (pathname?.includes(pageNames?.returnSteps) ||
      pathname?.includes(pageNames?.returnConfirmation)) &&
    !enableHeaderMFE()

  const isFromJitsuSfSignup =
    enableJitsuSF() &&
    (pathname?.includes(pageNames?.signUp) ||
      pathname?.includes(pageNames?.jitsuParticipantsInvite))

  return (
    isRegionPage ||
    isNativeAppQueryParam ||
    isNativeApp ||
    isKlarnaCheckoutPage ||
    isFromReturn ||
    isFromJitsuSfSignup
  )
}

export {
  getHardCodedMenusIN,
  createAdditionalShopItems,
  createAdditionalProfessionalCareItems,
  getCategoryLinks,
  getConsent,
  isEnableReEnrollNotificationPopup,
  shouldSuppressHeaderAndModals,
  showTempPopup,
  checkIfReEnroll,
  enableToshowBlackOutDateSelection,
  isEnableMemberAgreementCheckout,
  isEnableExpressCheckoutMemberAgreement,
  isEnableExpressCheckoutMemberAgreementForRegisteredUser,
  isEnableIronCladIntegrationAPI,
  isEnableMemberAgreementsChange,
}
